import cn from "classnames";
import { FC } from "react";
import { bem } from "../../utils/bem";
import type { CardProps } from "./CardProps";
import "./Card.scss";

const b = bem("card");

export const Card: FC<CardProps> = ({ children, className, content, ...rest }) => {
  return (
    <div className={cn(className, b({ content }))} {...rest}>
      {children}
    </div>
  );
};
